<template>
  <div>
    <Carousel3d id="carousel-offers" 
        border="0" 
        startIndex="1" 
        :clickable="false" 
        v-bind:controlsVisible="true" 
        width="250" 
        height="700" 
        space="280" 
        perspective="0"
        controlsWidth="25"
        controlsHeight="80"
        inverseScaling="0"
        v-bind:loop="true"
        v-bind:minSwipeDistance="50">
    
        <Slide :index="0" class="offre publishing">  
            <div class="title">
                <h2>{{ $t("home.offers.publishing") }}</h2>
            </div>
            <div class="content">
                <p>{{ $t("home.offers.publishing.content") }}</p>
                <div class="univers football">
                  <b-link href="https://www.football-addict.com/fr" target="_blank">
                    <div class="title">
                      <div class="title-baseline">Football</div> 
                      <div class="title-subline">Addict</div>
                    </div>
                  </b-link>
                </div>
                <div class="univers rugby">
                  <b-link href="https://www.rugby-addict.com/fr" target="_blank">
                    <div class="title">
                      <div class="title-baseline">Rugby</div> 
                      <div class="title-subline">Addict</div>
                    </div>
                  </b-link>
                </div>
                <div class="univers motors">
                  <b-link href="https://www.motors-addict.com/fr" target="_blank">
                    <div class="title">
                      <div class="title-baseline">Motors</div> 
                      <div class="title-subline">Addict</div>
                    </div>
                  </b-link>
                </div>
                <div class="univers news">
                  <b-link href="https://www.news-addict.com/fr" target="_blank">
                    <div class="title">
                      <div class="title-baseline">News</div> 
                      <div class="title-subline">Addict</div>
                    </div>
                  </b-link>
                </div>
            </div>
            <div class="cta">
                <b-link :href="$t('home.offers.publishing.cta.link')" v-html="$t('home.offers.publishing.cta')" ></b-link>
            </div>
        </Slide>

        <Slide :index="1" class="offre posting">
            <div class="title">
                <h2>{{ $t("home.offers.posting") }}</h2>
            </div>
            <div class="content">
                <div v-html="$t('home.offers.posting.content')"></div>
                <img alt="screenshot posting" src="../../assets/screenshot-posting.png"/>
                <b>{{ $t("home.offers.posting.content.bold") }}</b>
            </div>
            <div class="cta">
                <b-link href="https://landing.mashup-web.com/" target="_blank">{{ $t("home.offers.posting.cta") }}</b-link>
            </div>
        </Slide>

        <Slide :index="2" class="offre curation">
            <div class="title">
                <h2>{{ $t("home.offers.curation") }}</h2>
            </div>
            <div class="content">
                <div v-html="$t('home.offers.curation.content')"></div>
                <br/>
                <b>{{ $t("home.offers.curation.content.bold") }}</b>
            </div>
            <div class="cta">
                <b-link :href="$t('home.offers.curation.cta.link')" v-html="$t('home.offers.curation.cta')" ></b-link>
            </div>
        </Slide>

    </Carousel3d>
  </div>
</template>

<script>
  import { Carousel3d, Slide } from 'vue-carousel-3d';

  export default {
    name: "CarouselOffers3d",
    components: {
      Carousel3d,
      Slide
    },
    mounted: () => {
      if(document.head.querySelector("#mailmunch-script") != null)
        document.head.querySelector("#mailmunch-script").remove()
      let mailMunchScript = document.createElement('script')
      mailMunchScript.setAttribute('src', '//a.mailmunch.co/app/v1/site.js')
      mailMunchScript.setAttribute('id', 'mailmunch-script')
      mailMunchScript.setAttribute('data-mailmunch-site-id', '709732')
      mailMunchScript.setAttribute('async', 'async')
      document.head.appendChild(mailMunchScript)
    }
  }
</script>

<style scoped>
  .offre {
    width: 288px;
    padding: 20px;
  }
  .offre.posting {
    background: linear-gradient(150deg, rgba(194,68,151,0.8) 50px, #c24497, #4e0b5a 101%);
    box-shadow: 0 14px 31px -9px rgba(106, 31, 124, 0.75);
  }
  .offre.publishing {
    background: linear-gradient(150deg, rgba(37,55,175,0.8) 50px, #2537af, #0e1b5f 101%);
    box-shadow: 0 14px 31px -9px rgba(20, 111, 115, 0.55);
  }
  .offre.curation {
    background: linear-gradient(150deg, rgba(12,178,213,0.8) 50px, #0cb2d5, #1381b8 101%);
    box-shadow: 0 14px 31px -9px rgba(78, 145, 204, 0.76);
  }
  .offre .title span {
    font-size: 8px;
    font-weight: 600;
  }
  .offre .title h2 {
    font-size: 28px;
    font-weight: 600;
    text-align: center;
  } 

  .offre .content {
    margin-top: 40px;
    font-size: 16px;
    text-align: left;
    line-height: 17px;
  }
  .offre .content p {
    margin-bottom: 10px;
  }
  .offre.posting img {
    margin: 15px 0;
  }
  .offre.publishing .content .univers {
    width: 100%;
    height: 90px;
    background: rgba(0, 0, 0, 0.36);
    position: relative;
    text-align: center;
  }
  .offre.publishing .content .univers a:before {
    content: ' ';
    width: 45px;
    height: 45px;
    position: absolute;
    margin-left: -85px;
    top: 50%;
    transform: translateY(-50%);
  }
  .offre.publishing .content .univers.football {
    background: #388e3c;
  }
  .offre.publishing .content .univers.football a:before {
    background: url('https://cdn.mashup-web.com/img/header/logo-football.png') no-repeat;
    background-size: 100%;
  }
  .offre.publishing .content .univers.rugby {
    background: #274e9d;
  }
  .offre.publishing .content .univers.rugby a:before {
    background: url('https://cdn.mashup-web.com/img/header/logo-rugby.png') no-repeat;
    background-size: 100%;
  }
  .offre.publishing .content .univers.motors {
    background: #c51b12;
  }
  .offre.publishing .content .univers.motors a:before {
    background: url('https://cdn.mashup-web.com/img/header/logo-motors.png') no-repeat;
    background-size: 100%;
  }
  .offre.publishing .content .univers.news {
    background: #182436;
  }
  .offre.publishing .content .univers.news a:before {
    background: url('https://cdn.mashup-web.com/img/header/logo-news.png') no-repeat;
    background-size: 100%;
  }
  .offre.publishing .content .univers a {   
    line-height: 90px;
    font-size: 18px;
    font-weight: 500;
  }
  .offre.publishing .content .univers a:after {
    content: '';
    position: absolute;
    width: 25px;
    height: 25px;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    background: url(../../assets/Small-Arrow.svg) no-repeat;
    background-size: 100%;
  }
  .offre.publishing .content .univers .title {
    line-height: 1.3;
    text-align: left;
    display: inline-block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .offre.publishing .content .univers .title .title-subline {
      font-size: 16px;
  }

  .offre .cta {
    text-align: center;
    font-size: 22px;
    font-weight: 500;
    position: absolute;
    bottom: 25px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    padding: 0 10px;
  }
  .offre .cta a:before { 
    content: '';
    position: absolute;
    width: 40px;
    height: 40px;
    left: 50%;
    transform: translateX(-50%);
    top: -45px;
  }
  .offre.posting .cta a:before { 
    background: url(../../assets/CTA-1.svg) no-repeat;
    background-size: 100%;
  }
  .offre.publishing .cta a:before { 
    background: url(../../assets/CTA-2.svg) no-repeat;
    background-size: 100%;
  }
  .offre.curation .cta a:before { 
    background: url(../../assets/CTA-3.svg) no-repeat;
    background-size: 100%;
  }
  .offre .cta a span {
    font-size: 11px !important;
    display: block;
  } 

  /* desktop */
  @media (min-width: 850px){
    .offre.posting {
      transform: translateX(0) translateZ(0) rotateY(0deg) !important;
    }
    .offre.publishing {
      transform: translateX(-280px) translateZ(0) rotateY(0deg) !important;
    }
    .offre.curation {
      transform: translateX(280px) translateZ(0) rotateY(0deg) !important;
    }
  }
</style>
